import axios from "axios";

export const apiUrl = import.meta.env.VITE_API_URL;
const getEnv = import.meta.env.VITE_APP_ENV
export const chatbotUrl = getEnv === "PROD" ? apiUrl + "/chatapi/" : "http://localhost:9000"; // or production chat URL

// Main API instance
const instance = axios.create({ baseURL: apiUrl });

// Chat API instance
export const chatinstance = axios.create({ baseURL: chatbotUrl });

/* ---------------------- COMMON REQUEST INTERCEPTOR ---------------------- */
const requestInterceptor = (config) => {
  const imo_number = localStorage.getItem("imo_number");
  const checkrole = localStorage.getItem("role");
  const token = localStorage.getItem("accessToken");

  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  if (imo_number) config.headers["imo_number"] = imo_number;
 
  return config;
};

/* ---------------------- COMMON RESPONSE INTERCEPTOR ---------------------- */
const responseInterceptor = {
  success: (response) => response.data,
  error: (error) => {
    const errorMessage =
      error?.response?.data?.error || error.message || "Something went wrong.";

    console.log("API Error:", errorMessage);

    if (error?.response?.status === 403 && errorMessage === "invalid_token") {
      clearAuthData();
      window.location.href = "/login";
    }

    if (
      error?.response?.status === 401 &&
      error?.response?.data?.error?.toLowerCase().includes("jwt")
    ) {
      clearAuthData();
      window.location.href = "/login";
      return Promise.reject("Session expired. Redirecting to login.");
    }

    return Promise.reject({ success: false, error: errorMessage, data: error?.response?.data });
  },
};

/* ---------------------- Attach interceptors ---------------------- */
instance.interceptors.request.use(requestInterceptor, Promise.reject);
chatinstance.interceptors.request.use(requestInterceptor, Promise.reject);

instance.interceptors.response.use(responseInterceptor.success, responseInterceptor.error);
chatinstance.interceptors.response.use(responseInterceptor.success, responseInterceptor.error);

/* ---------------------- Helpers ---------------------- */
const clearAuthData = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("username");
  localStorage.removeItem("ship_id");
  localStorage.removeItem("reset_new");
  localStorage.removeItem("role");
};

export default instance;
